import { Component } from '@angular/core';

@Component({
  selector: 'tr-default-page',
  templateUrl: './default-page.component.html',
  //styleUrls: ['./default-page.component.scss']
})
export class DefaultPageComponent {

}



// WEBPACK FOOTER //
// ./src/app/shared/components/default-page/default-page.component.ts